import type { CharacterProfile } from '../types';

export function FighterArmToast({ character, slot }: { character: CharacterProfile; slot: number }) {
  return (
    <aside className="fighter-arm-toast" aria-live="assertive" aria-label={`${character.name} armed for the next versus draw`}>
      <img src={character.isBoss ? character.images[0].src : `/assets/cameos/${character.id}.webp`} alt="" width="256" height="256" />
      <div><strong>TOASTY!</strong><span>CHALLENGER {slot} ARMED</span><b>{character.name}</b></div>
    </aside>
  );
}
